import GetCompanyByExternalIdAndEventIdentifierAsyncRequestModelBase from '../_generated/modelBases/get-company-by-external-id-and-event-identifier-async-request-model-base';

export default class GetCompanyByExternalIdAndEventIdentifierAsyncRequestModel extends GetCompanyByExternalIdAndEventIdentifierAsyncRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
